import { Box, Drawer, Stack, Typography, useTheme } from "@mui/material";
import type { ReactNode, SyntheticEvent } from "react";
import { DrawerGrabber } from "web_myplann/Shared/Components/DrawerGrabber";
import { useCloseOnBackPress } from "web_myplann/Shared/Hooks/useCloseOnBackPress";
import { useSwipeToClose } from "web_myplann/Shared/Hooks/useSwipeToClose";

type Props = {
	open: boolean;
	onClose: () => void;
	title?: string;
	children: ReactNode;
};

export const SmallDrawer = ({ open, onClose, title, children }: Props) => {
	const { colors, palette } = useTheme();
	const swipeToClose = useSwipeToClose(onClose);
	useCloseOnBackPress(open, onClose);

	return (
		<Drawer
			anchor="bottom"
			open={open}
			onClose={() => onClose()}
			ModalProps={{
				sx: { zIndex: (t) => t.zIndex.drawer + 1 },
			}}
			slotProps={{
				paper: {
					sx: {
						paddingBottom: "min(env(safe-area-inset-bottom, 0px), 10px)",
					},
					onClick: (e: SyntheticEvent) => {
						e.stopPropagation();
					},
				},
			}}
		>
			<Stack component="header" {...swipeToClose} sx={{ touchAction: "none" }}>
				<DrawerGrabber />
				{title && (
					<Box px={1.6} pb={1.2}>
						<Typography variant="h3" textAlign="left">
							{title}
						</Typography>
					</Box>
				)}
			</Stack>
			<Box borderBottom={colors.border.solid(palette.grey[100])} />
			<Stack
				sx={{
					flex: "1 1 auto",
					overflowY: "auto",
				}}
			>
				{children}
			</Stack>
		</Drawer>
	);
};
